var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h2", { staticClass: "page-title-bar" }, [
        _c("i", { staticClass: "ico ico-user" }),
        _vm._v(_vm._s(_vm.$t("User Access")) + " ")
      ]),
      _c(
        "v-row",
        { staticClass: "mt-10" },
        [
          _c("v-col", { attrs: { cols: "4" } }, [
            _c("h3", { staticClass: "page-sub-title-bar" }, [
              _vm._v(" " + _vm._s(_vm.$t("Select the store for mapping")) + " ")
            ]),
            _c("div", { staticClass: "select_store_box mt-5" }, [
              _c("h4", { staticClass: "select_article is-complete" }, [
                _vm._v(_vm._s(_vm.$t("Company")))
              ]),
              _c(
                "div",
                { staticClass: "forms-area" },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.companyItems,
                      label: "" + _vm.$t("Select the company"),
                      "item-text": "companyItems.company",
                      "item-value": "companyItems.company",
                      disabled: _vm.disabledCompany,
                      "clearable:false": "",
                      dense: "",
                      flat: "",
                      "hide-details": "",
                      solo: ""
                    },
                    on: {
                      change: function($event) {
                        return _vm.changeedCompany()
                      }
                    },
                    model: {
                      value: _vm.selectedCompany,
                      callback: function($$v) {
                        _vm.selectedCompany = $$v
                      },
                      expression: "selectedCompany"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "select_store_box" }, [
              _c("h4", { ref: "country", staticClass: "select_article" }, [
                _vm._v(_vm._s(_vm.$t("Country")))
              ]),
              _c(
                "div",
                { staticClass: "forms-area" },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.countryItems,
                      label: "" + _vm.$t("Select the country"),
                      "clearable:false": "",
                      dense: "",
                      flat: "",
                      "hide-details": "",
                      solo: "",
                      clearable: ""
                    },
                    on: {
                      change: function($event) {
                        return _vm.changeedCountry()
                      }
                    },
                    model: {
                      value: _vm.selectedCountry,
                      callback: function($$v) {
                        _vm.selectedCountry = $$v
                      },
                      expression: "selectedCountry"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "select_store_box" }, [
              _c("h4", { ref: "region", staticClass: "select_article" }, [
                _vm._v(_vm._s(_vm.$t("Region")))
              ]),
              _c(
                "div",
                { staticClass: "forms-area" },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.regionItems,
                      label: "" + _vm.$t("Select the region"),
                      "clearable:false": "",
                      dense: "",
                      flat: "",
                      "hide-details": "",
                      solo: "",
                      clearable: ""
                    },
                    on: {
                      change: function($event) {
                        return _vm.changeedRegion()
                      }
                    },
                    model: {
                      value: _vm.selectedRegion,
                      callback: function($$v) {
                        _vm.selectedRegion = $$v
                      },
                      expression: "selectedRegion"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "select_store_box" }, [
              _c("h4", { ref: "city", staticClass: "select_article" }, [
                _vm._v(_vm._s(_vm.$t("City")))
              ]),
              _c(
                "div",
                { staticClass: "forms-area" },
                [
                  _c("v-select", {
                    attrs: {
                      items: _vm.cityItems,
                      label: "" + _vm.$t("Select the city"),
                      "clearable:false": "",
                      dense: "",
                      flat: "",
                      "hide-details": "",
                      solo: "",
                      clearable: ""
                    },
                    on: {
                      change: function($event) {
                        return _vm.changeedCity()
                      }
                    },
                    model: {
                      value: _vm.selectedCity,
                      callback: function($$v) {
                        _vm.selectedCity = $$v
                      },
                      expression: "selectedCity"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "select_store_box" }, [
              _c("h4", { ref: "store", staticClass: "select_article" }, [
                _vm._v(_vm._s(_vm.$t("Store")))
              ]),
              _c(
                "div",
                { staticClass: "forms-area list" },
                [
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item-group",
                        {
                          attrs: { "active-class": "list-select" },
                          model: {
                            value: _vm.selectedStore,
                            callback: function($$v) {
                              _vm.selectedStore = $$v
                            },
                            expression: "selectedStore"
                          }
                        },
                        _vm._l(_vm.storeItems, function(item, i) {
                          return _c(
                            "v-list-item",
                            {
                              key: i,
                              attrs: { value: item.code + "," + item.name }
                            },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", {
                                    domProps: {
                                      textContent: _vm._s(
                                        item.name + "(" + item.code + ")"
                                      )
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ]),
          _c(
            "v-col",
            {
              staticClass: "d-flex justify-center align-center",
              attrs: { cols: "1" }
            },
            [
              _c("img", {
                attrs: {
                  src: require("@/assets/img/ico-next-step.png"),
                  alt: ""
                }
              })
            ]
          ),
          _c(
            "v-col",
            { attrs: { cols: "7" } },
            [
              _c("h3", { staticClass: "page-sub-title-bar" }, [
                _vm._v(_vm._s(_vm.$t("User-Store Mapping")))
              ]),
              _c(
                "v-data-table",
                {
                  staticClass: "tbl-type02 mt-5 rounded-bl-0",
                  attrs: {
                    headers: _vm.tableHeaders,
                    items: _vm.tableItems,
                    page: _vm.page,
                    "items-per-page": 10,
                    "hide-default-footer": true,
                    "item-key": "account",
                    "show-select": "",
                    height: "590",
                    "single-select": false
                  },
                  on: {
                    "update:page": function($event) {
                      _vm.page = $event
                    }
                  },
                  model: {
                    value: _vm.selectedSaveUsers,
                    callback: function($$v) {
                      _vm.selectedSaveUsers = $$v
                    },
                    expression: "selectedSaveUsers"
                  }
                },
                [
                  _c("template", { slot: "no-data" }, [
                    _c("p", [
                      _vm._v(" " + _vm._s(_vm.$t("No data available")) + " ")
                    ])
                  ])
                ],
                2
              ),
              _c(
                "div",
                [
                  _c("UserPopup", {
                    attrs: {
                      rtnStore: _vm.rtnStore,
                      dialog_UserPopup: _vm.dialog_UserPopup
                    },
                    on: { closeUserPopup: _vm.closeUserPopup }
                  }),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn t-bottom",
                      attrs: { text: "", disabled: _vm.buttonDisabled },
                      on: { click: _vm.openUserPopup }
                    },
                    [_vm._v(_vm._s(_vm.$t("Add")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn t-bottom ml-2",
                      attrs: { text: "", disabled: _vm.buttonDisabled },
                      on: { click: _vm.deleteUserList }
                    },
                    [_vm._v(_vm._s(_vm.$t("Delete")))]
                  )
                ],
                1
              ),
              _c("div", { staticStyle: { position: "relative" } }, [
                _c("div", { staticClass: "pageInfodata" }, [
                  _vm._v(" " + _vm._s(_vm.pageInfoText) + " ")
                ]),
                _c(
                  "div",
                  [
                    _c("v-pagination", {
                      staticClass: "pageAlign",
                      attrs: { length: _vm.totalPages, "total-visible": 7 },
                      on: { input: _vm.paging },
                      model: {
                        value: _vm.page,
                        callback: function($$v) {
                          _vm.page = $$v
                        },
                        expression: "page"
                      }
                    })
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("a", { ref: "link", style: { display: "none" } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }